interface TypeChipProps {
  type: "billable" | "overhead";
}

export function TypeChip({ type }: TypeChipProps) {
  return <span className={`badge badge--${type}`}>{type}</span>;
}
